import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteAContentBlock,
  getContentBlocks,
  resetState,
} from "../../features/cms/contentBlocks/cmsContentBlocksSlice";
import CustomModal from "../../components/CustomModal";
import { delImg } from "../../features/upload/uploadSlice";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Type",
    dataIndex: "type",
  },
  {
    title: "Active",
    dataIndex: "active",
  },
  {
    title: "Order",
    dataIndex: "order",
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const ContentBlockList = () => {
  const [open, setOpen] = useState(false);
  const [blockId, setBlockId] = useState("");
  const showModal = (e) => {
    setOpen(true);
    setBlockId(e);
  };

  const hideModal = () => {
    setOpen(false);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetState());
    dispatch(getContentBlocks());
  }, [dispatch]);
  const getBlockState = useSelector(
    (state) => state.cmsContentBlocks.contentBlocks
  );
  const data1 = [];
  for (let i = 0; i < getBlockState.length; i++) {
    data1.push({
      key: i + 1,
      name: getBlockState[i].name,
      type: getBlockState[i].type,
      active: getBlockState[i].isActive ? "Yes" : "No",
      order: getBlockState[i].order || 0,
      action: (
        <>
          <Link
            to={`/admin/cms/content-block/${
              getBlockState[i]._id || getBlockState[i].id
            }`}
            className=" fs-3 text-danger"
          >
            <BiEdit />
          </Link>
          <button
            className="ms-3 fs-3 text-danger bg-transparent border-0"
            onClick={() =>
              showModal(getBlockState[i]._id || getBlockState[i].id)
            }
          >
            <AiFillDelete />
          </button>
        </>
      ),
    });
  }
  const deleteBlock = (e) => {
    dispatch(deleteAContentBlock(e));
    dispatch(delImg(e));

    setOpen(false);
    setTimeout(() => {
      dispatch(getContentBlocks());
    }, 100);
  };
  return (
    <div>
      <h3 className="mb-4 title">Content Blocks List</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => {
          deleteBlock(blockId);
        }}
        title="Are you sure you want to delete this content block?"
      />
    </div>
  );
};

export default ContentBlockList;

